import { t } from 'i18next';

import { ErrorResponseErrorItemCodeAssetTag } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeAssetTag, string> => ({
  'asset-tag:already_exists': t('assetTag.alreadyExists', {
    ns: 'apiErrorCodes',
    defaultValue: 'Taggen finns redan.',
  }),
  'asset-tag:not_found': t('assetTag.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Taggen hittades inte.',
  }),
  'asset-tag:poi_and_tag_different_project': t('assetTag.poiAndTagDifferentProject', {
    ns: 'apiErrorCodes',
    defaultValue: 'Taggen och POI tillhör olika projekt.',
  }),
  'asset-tag:user_unauthorized': t('assetTag.userUnauthorized', {
    ns: 'apiErrorCodes',
    defaultValue: 'Du har inte tillgång till denna tagg.',
  }),
});
